import React from "react";
import '../assets/styles/IntroSection.css'; // Adjust the path as necessary

const IntroSection = () => {
    return ( 
        <main ClassName="main-flex" role="main">
            <div ClassName="content-column">
                <section>
                    <h2 ClassName = "introhead">Salutations Fellow Packet Pushers</h2>
                    <section ClassName="intro">
                        <p>
                        Welcome to my digital fortress. I’m <strong>BobTheSkull</strong>, a self-taught cyber-sleuth and code crafter.  
                        Here you’ll find my latest exploits—write-ups from pwned machines, side projects that push the envelope,  
                        and the toolkit I swear by when I’m deep in the packet jungle. Pull up a terminal, explore around, and let’s  
                        build, break, and secure the future together.
                        </p>
                    </section>
                </section>
            </div>
        </main>
    );
};

export default IntroSection;